import { ExternalCallbackRegistry } from "../IExternalCallback";
import ServiceRegistry from "../ServiceRegistry";
import Resource from "./Resource";
import ResourceLoader from "./ResourceLoader";

export default class ResourceUtil {
	private static TARGET = "ui";

	/**
	 * @param onSuccess called when all script resources are loaded
	 */
	public static loadRemoteResources(onSuccess?: () => void) {

		// init callback registry so impl tool scripts can register callbacks for now.
		// TODO at least don't load the callback functions from context setting file resources.
		// these should be somewhere in git.
		ExternalCallbackRegistry.init();

		ServiceRegistry.getQueryService().findMany(Resource, {target: ResourceUtil.TARGET}).then((r) => {
			const response = r as any;

			if(response.data) {

				let loaded = 0;
				const count = (response.data.entities || []).filter((o: Resource) => o.type === 'script').length;


				const onLoaded = () => {
					loaded++;
					if (loaded === count && typeof onSuccess === 'function') {
						onSuccess();
					}
				};

				for(const resource of response.data.entities) {
					if(resource.type === "script") {
						ResourceLoader.loadScript(resource.url, onLoaded); // fix for cdn
					}

					if(resource.type === "stylesheet") {
						ResourceLoader.loadStyle(resource.url);
					}

					if(resource.type === 'favicon') {
						ResourceLoader.loadFavicon(resource.url);
					}
				}

				if (typeof onSuccess === 'function') {
					onSuccess();
				}
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/core/util/resource/ResourceUtil.ts